export const fallbackLang = {
  optimized_checkout: {
    its_event_manager: {
      payment_step_notice: 'GolfBags.com is a TGIB Marketing, Inc. Company',
    },
  },
};
